import styled from 'styled-components';

import Page from 'components/layouts/page/Page';
import { BodySmall, H2 } from 'styles/typography';

import ReferralForm from './ReferralForm';

export default function NewInboundReferralPage() {
  return (
    <Page>
      <Page.Header>
        <HeaderInner>
          <H2>New inbound referral</H2>
          <BodySmall>Start a referral intake for one of your buildings.</BodySmall>
        </HeaderInner>
      </Page.Header>
      <Page.Content>
        <ReferralForm />
      </Page.Content>
    </Page>
  );
}

const HeaderInner = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
